import { safeJson } from "src/app/helpers/Index";
import { faPencil, faTrashAlt, faWarning } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { Calendar } from "primereact/calendar";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { FileUpload } from "primereact/fileupload";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
import { TabView, TabPanel } from 'primereact/tabview';
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React from "react";
import { ResizeImage } from "src/app/helpers/ResizeImage";
import { Col, Dropdown, Row } from "react-bootstrap";
import { SystemSetting } from "src/app/interfaces/Index";
import { FileService, SystemSettingService } from "src/app/services/Index";
import { colours } from "src/app/Styles";
import "./AdminSystemSettings.css";
import { InputSwitch } from "primereact/inputswitch";

type Props = {};
type State = {
	activeTab: number;
	filteredSettings: SystemSetting[];
	settings: SystemSetting[];
	isLoading: boolean;
	selectedSetting: SystemSetting;
	selectedSettings: SystemSetting[];
	showSettingInfoModal: boolean;
	submitted: boolean;
};
const valueOptions = [{label:'True', value:'True'},{label:'False',value:'False'}];

export class AdminSystemSettings extends React.Component<Props, State> {
	dt: any;
	toast: any;

	constructor(props: Props) {
		super(props);
		this.state = { activeTab: 0, filteredSettings: [], settings: [], isLoading: false, selectedSetting: new SystemSetting(), selectedSettings: [], showSettingInfoModal: false, submitted: false};
	}

	categoryChange(e: any) {
		let selectedSetting = { ...this.state.selectedSetting };
		// selectedSetting.type = e.value;
		this.setState({ selectedSetting });
	}

	changeTab(e: any) {
		let filteredLocalSettings = this.state.settings.filter(setting => setting.systemSettingGroupId == e + 1)
		this.setState({ filteredSettings: filteredLocalSettings, activeTab: e });
	}

	componentDidMount() {
		this.getSettings();
	}

	settingInfoFooter() {
		return (
			<>
				<Button className="p-button-text" icon="pi pi-times" label="Cancel" onClick={() => this.setState({ selectedSetting: new SystemSetting(), showSettingInfoModal: false })}></Button>
				<Button className="p-button-text" icon="pi pi-check" label="Save" onClick={() => this.saveSetting()}></Button>
			</>
		);
	}

	async getSettings() {
		this.setState({ isLoading: true });
		const res = await safeJson(SystemSettingService.getAll());
		if (res && res.error) {
			this.toast.show({ closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!" });
			this.setState({ isLoading: false });
		}

		let filteredSettings: SystemSetting[] = res;

		this.setState({ settings: res, filteredSettings: filteredSettings.filter(x => x.systemSettingGroupId == this.state.activeTab + 1), isLoading: false });
	}

	inputChange(e: any, name: string) {
		console.log(e);
		const val = (e.target && e.target.value) || "";
		let selectedSetting = new SystemSetting({ ...this.state.selectedSetting });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedSetting[name] = val;
		this.setState({ selectedSetting });
	}

	inputNumberChange(e: any, name: string) {
		const val = e.value || 0;
		let selectedSetting = new SystemSetting({ ...this.state.selectedSetting });
		// @ts-ignore // Required to be able to use a generic function to change the values
		selectedSetting[name] = val;
		this.setState({ selectedSetting });
	}

	render() {
		return (
			<>
				<Row>
					<Col>
						<div className="card" style={{ paddingTop: "1.5rem" }}>
							<h5 style={{paddingBottom: "1rem", paddingLeft: "1.5rem"}}>System Settings</h5>
							<TabView activeIndex={this.state.activeTab} onTabChange={(e) => this.changeTab(e.index)}>
								<TabPanel header="Email Settings"></TabPanel>
								<TabPanel header="Mime Types"></TabPanel>
								<TabPanel header="Password Settings"></TabPanel>
								<TabPanel header="SMS Settings"></TabPanel>
								<TabPanel header="Push Notification Settings"></TabPanel>
								<TabPanel header="Service Area Settings"></TabPanel>
								<TabPanel header="Order Settings"></TabPanel>
								<TabPanel header="Chef Settings"></TabPanel>
							</TabView>
							<DataTable loading={this.state.isLoading} onSelectionChange={(e) => this.setState({selectedSettings: e.value})} ref={(el) => this.dt = el} scrollable scrollHeight="flex" scrollDirection="vertical" selection={this.state.selectedSettings} style={{height: "calc(100vh - 18rem)"}} value={this.state.filteredSettings} resizableColumns>
								<Column field="label" header="Name" style={{width: "20%"}} sortable></Column>
								<Column field="value" header="Value" style={{width: "70%"}} sortable></Column>
								<Column style={{width: "10", alignContent: "right"}} body={(rowData) => (
									<div className="actions">
										<Button onClick={() => this.setState({selectedSetting: rowData, showSettingInfoModal: true})} style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, height: 30, justifyContent: "center", margin: 2, padding: 0, width: 30, float: "right"}}>
											<FontAwesomeIcon icon={faPencil} style={{ color: colours.white }}></FontAwesomeIcon>
										</Button>
									</div>
								)}></Column>
							</DataTable>
							<Dialog className="p-fluid" footer={() => this.settingInfoFooter()} header="Setting Details" modal onHide={() => this.setState({showSettingInfoModal: false})} style={{width: "75%" }} visible={this.state.showSettingInfoModal}>
								<p className="warningLabel"><FontAwesomeIcon icon={faWarning} style={{color: colours.black, fontSize: 15, width: 40}}></FontAwesomeIcon>WARNING! Changing any system settings may result in unexpected behaviour for users of the system.</p>
								<div className="field" style={{marginBottom: 10}}>
									<label htmlFor="label">Setting Name</label>
									<InputText autoFocus className={classNames({"p-invalid": this.state.submitted && !this.state.selectedSetting.label})} id="label" onChange={(e) => this.inputChange(e, "label")} required value={this.state.selectedSetting.label} />
									{this.state.submitted && !this.state.selectedSetting.label &&
										<small className="p-invalid">Name is required.</small>
									}
								</div>
								{this.renderValueField(this.state.selectedSetting.value)}
							</Dialog>
						</div>
					</Col>
				</Row>
				<Toast ref={(el) => this.toast = el}></Toast>
			</>
		);
	}

	renderLeftToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-plus" label="New" style={{backgroundColor: colours.graphs.positive, borderColor: colours.graphs.positive, marginRight: 10}} onClick={() => this.setState({selectedSetting: new SystemSetting(), showSettingInfoModal: true})}></Button>
			</>
		);
	}

	renderRightToolbarButtons() {
		return (
			<>
				<Button icon="pi pi-upload" label="Export" style={{backgroundColor: colours.buttons.export, borderColor: colours.buttons.export, marginLeft: 10}} onClick={() => this.dt.exportCSV()}></Button>
			</>
		);
	}

	renderValueField(value: String) {
		// 	console.log(value);
		// 	if(value == "true" || value == "false"){
		// 	return (
		// 	<>
		// 	<div className="field col">
		// 	<label htmlFor="settingValue">Available for subscription</label><br />
		// 	<InputSwitch checked={this.state.selectedSetting.value == "true" ? true : false} id="settingValue" onChange={(e) => this.inputChange(e, "value")}/>
		// 	</div>
		// 	</>
		// 	);
		// }else{
		return (
			<>
				<div className="field" style={{ marginBottom: 10 }}>
					<label htmlFor="value">Setting Value</label>
					<InputText autoFocus className={classNames({ "p-invalid": this.state.submitted && !this.state.selectedSetting.value })} id="value" onChange={(e) => this.inputChange(e, "value")} required value={this.state.selectedSetting.value} />
					{this.state.submitted && !this.state.selectedSetting.value &&
						<small className="p-invalid">Value is required.</small>
					}
				</div>
			</>
		);
		// }

	}

	async saveSetting() {
		const res = await safeJson(SystemSettingService.updateSingleById(this.state.selectedSetting.id, this.state.selectedSetting));
		if (res && res.error) {
			this.toast.show({closable: false, detail: "Please try again later.", life: 5000, severity: "error", summary: "Something went wrong!"});
			this.setState({isLoading: false });
		}
		this.getSettings();
		this.setState({isLoading: false, showSettingInfoModal: false});
		this.toast.show({closable: false, detail: "Your discount code has been saved", life: 5000, severity: "success", summary: "Code saved!"});
	}

	async uploadImage(data: any, property: string) {
		const containerName = "images";
		const uploadData = new FormData();
		uploadData.append("containerName", containerName);
		uploadData.append("files", await ResizeImage(data.files[0]));
		uploadData.append("mimeTypeKey", "Images");
		const response = await safeJson(FileService.upload(uploadData));
		let tempItem = { ...this.state.selectedSetting };
		// @ts-ignore // Required to be able to change the values
		tempItem[property] = `${environment.server.storageUrl}/${response[0].location}`;
		await this.setState({selectedSetting: tempItem});
	}
}